import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import TopBar from "../../components/TopBar";
import { serverDomain } from "../../config";
import SideBar from "../../components/SideBar";
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';  // Для стрелочек
import "../../styles/fl-pages.css"


const StatisticsPage = () => {
    const [userLinks, setUserLinks] = useState([]);
    const [statistics, setStatistics] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [interval, setInterval] = useState("по дням");      // для бэка / агрегации
const [intervalUi, setIntervalUi] = useState("по дням");  // что сейчас показано в селекте
    const [groupBy, setGroupBy] = useState("none");
    const [sortColumn, setSortColumn] = useState("period"); // Колонка для сортировки
    const [sortOrder, setSortOrder] = useState("desc"); // Направление сортировки
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const isNewlyRegistered = localStorage.getItem('isNewlyRegistered');
    const [loading, setLoading] = useState(false);

    const [selectedStreams, setSelectedStreams] = useState([]);
    const [selectedOffers, setSelectedOffers] = useState([]);
    const [allStreams, setAllStreams] = useState([]); // Все потоки
    const [allOffers, setAllOffers] = useState([]); // Все офферы
    const [showFilters, setShowFilters] = useState(false); // Состояние для управления видимостью фильтров


    const setToday = () => {
        const today = new Date();
        const d = formatDateMSK(today);
            setStartDate(d);
            setEndDate(d);
        setInterval("по дням"); // на всякий случай фиксируем
    };

    const setYesterday = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        const d = formatDateMSK(yesterday);
        setStartDate(d);
        setEndDate(d);
        setInterval("по дням");
    };


    const toggleFilters = () => {
        setShowFilters(!showFilters); // Переключаем видимость фильтров
    };

    const toggleStreamSelection = (stream) => {
        setSelectedStreams(prevSelected => {
            if (prevSelected.includes(stream)) {
                return prevSelected.filter(s => s !== stream);
            }
            return [...prevSelected, stream];
        });
    };

    const toggleOfferSelection = (offer) => {
        setSelectedOffers(prevSelected => {
            if (prevSelected.includes(offer)) {
                return prevSelected.filter(o => o !== offer);
            }
            return [...prevSelected, offer];
        });
    };
    
    const fetchFilters = async () => {
        try {
            const token = localStorage.getItem("token");

            const response = await fetch(
                `${serverDomain}/api/conversions/filters`,
                {
                    method: "GET",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            const data = await response.json();
            setAllStreams(data.streams);
            setAllOffers(data.offers);
        } catch (error) {
            console.error("Ошибка загрузки фильтров:", error);
        }
    };

    useEffect(() => {
        fetchFilters();
    }, []);
    
    

    const handleUpdateLoading = () => {
        setLoading(true);
        setTimeout(() => {
            fetchStatistics();
            setLoading(false);
        }, 1000);
    };

    useEffect(() => {
        if (isNewlyRegistered) {
            localStorage.removeItem('isNewlyRegistered');
            localStorage.setItem('isAuthenticated', true);
            navigate('/');
        } else if (!isAuthenticated) {
            navigate('/login');
        }
    }, [isAuthenticated, isNewlyRegistered, navigate]);

    const formatDateMSK = (date) => {
        return new Date(date.getTime() + 3 * 60 * 60 * 1000) // Добавляем 3 часа
            .toISOString()
            .split('T')[0];
    };

    useEffect(() => {
        const today = new Date();
        const lastWeek = new Date();
        lastWeek.setDate(today.getDate() - 7);
        setStartDate(formatDateMSK(lastWeek));
        setEndDate(formatDateMSK(today));
        setInterval("по дням");
        setIntervalUi("по дням");
    }, []);
    

    const fetchStatistics = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }

        if (!startDate || !endDate) {
            return;
        }
    
        try {
            // Запрашиваем ссылки пользователя
            const resLinks = await fetch(`${serverDomain}/api/statistics/user-links`, {
                method: "GET",
                headers: { "Authorization": `Bearer ${token}` }
            });
    
            if (!resLinks.ok) {
                const errorData = await resLinks.json();
                throw new Error(errorData.error || "Ошибка при загрузке ссылок");
            }
    
            const links = await resLinks.json();
            if (!Array.isArray(links) || links.length === 0) {
                setUserLinks([]);
                return console.warn("Нет доступных ссылок");
            }
    
            setUserLinks(links);
    
            // 🔹 Запрашиваем статистику по каждой ссылке
            const statisticsPromises = links.map(async (link) => {
                try {
                    const res = await fetch(`${serverDomain}/api/statistics?link_name=${encodeURIComponent(link.raw_link_name ?? '')}&start_date=${startDate}&end_date=${endDate}&interval=${interval}&streams=${selectedStreams.join(',')}&offers=${selectedOffers.join(',')}`, {
                        method: "GET",
                        headers: { "Authorization": `Bearer ${token}` } // ✅ Передаём токен
                    });
    
                    if (!res.ok) {
                        const errorData = await res.json();
                        throw new Error(errorData.error || `Ошибка: ${res.status}`);
                    }
    
                    const data = await res.json();
                    if (!data || Object.keys(data).length === 0) return null;

    
                    data.offer_name = link.offer_name;
                    return data;
                } catch (error) {
                    console.error("Ошибка при получении статистики для ссылки:", error);
                    return null;
                }
            });
    
            const allStatistics = await Promise.all(statisticsPromises);
            const filteredStatistics = allStatistics.filter(stats => stats !== null);
    
            setStatistics(groupStatistics(filteredStatistics, interval, groupBy));
        } catch (error) {
            console.error("Ошибка при получении статистики:", error);
            alert(`Произошла ошибка: ${error.message}`);
        }
    };
    

    const groupStatistics = (data, interval, groupBy) => {
        const grouped = {};

        data.forEach(item => {
            for (const key in item) {
                let groupKey = key.split(' | ')[0]; // Период

                // Включаем название оффера, если группировка по офферу
                if (groupBy === 'offer') {
                    groupKey += ` | ${item.offer_name || 'Неизвестный оффер'}`;
                } else if (groupBy === 'stream') {
                    groupKey += ` | ${key.split(' | ')[1]}`;
                } else if (groupBy === 'landing') {
                    groupKey += ` | Fast Love RevShare`; // Временно
                }

                // Добавляем проверку на нулевые значения
                const stats = item[key];
                if (
                    stats.clicks === 0 &&
                    stats.registrations === 0 &&
                    stats.purchases === 0 &&
                    stats.income === 0 &&
                    (stats.tg_stars || 0) === 0
                  ) {
                    continue;
                  }
                  

                if (!grouped[groupKey]) {
                    grouped[groupKey] = {
                        clicks: 0,
                        registrations: 0,
                        purchases: 0,
                        tg_stars: 0,
                        purchase: 0,
                        auto_debit: 0,
                        income: 0,
                        cr: 0,
                        epc: 0,
                        count: 0,
                        offer_name: item.offer_name || "Неизвестный оффер" // Убедимся, что offer_name присутствует
                    };
                }

                grouped[groupKey].clicks += stats.clicks || 0;
                grouped[groupKey].registrations += stats.registrations || 0;
                grouped[groupKey].purchases += stats.purchases || 0;
                grouped[groupKey].purchase += stats.purchase || 0;
                grouped[groupKey].auto_debit += stats.auto_debit || 0;
                grouped[groupKey].income += parseFloat(stats.income) || 0;
                grouped[groupKey].count += 1;
                grouped[groupKey].tg_stars += stats.tg_stars || 0;
            }
        });

        // Вычисление CR и EPC
        for (const key in grouped) {
            const stats = grouped[key];
            stats.cr = stats.registrations > 0 ? (stats.purchase / stats.registrations) * 100 : 0;
            stats.epc = stats.clicks > 0 ? (stats.income / stats.clicks) : 0;
        }

        // Исключаем пустые строки с нулями
        for (const key in grouped) {
            const stats = grouped[key];
            if (
                stats.clicks === 0 &&
                stats.registrations === 0 &&
                stats.purchases === 0 &&
                stats.income === 0 &&
                (stats.tg_stars || 0) === 0
              ) {
                delete grouped[key];
              }
              
        }

        return grouped;
    };

    const handleIntervalChange = (e) => {
        const value = e.target.value;
        setIntervalUi(value);  // <- всегда обновляем то, что показано в селекте
      
        if (value === "today") {
          const today = new Date();
          const d = formatDateMSK(today);
          setStartDate(d);
          setEndDate(d);
          // агрегация по-прежнему "по дням"
          setInterval("по дням");
          return;
        }
      
        if (value === "yesterday") {
          const yesterday = new Date();
          yesterday.setDate(yesterday.getDate() - 1);
          const d = formatDateMSK(yesterday);
          setStartDate(d);
          setEndDate(d);
          setInterval("по дням");
          return;
        }
      
        // обычные варианты
        setInterval(value);
      };
      

    const sortedStatistics = useMemo(() => {
        return Object.entries(statistics).sort(([keyA, valueA], [keyB, valueB]) => {
            let valA, valB;

            if (sortColumn === "period") {
                const parseDate = (dateStr) => {
                    const [day, month, year] = dateStr.split('.').map(Number);
                    return new Date(year, month - 1, day).getTime();
                };

                valA = parseDate(keyA.split(" | ")[0]);
                valB = parseDate(keyB.split(" | ")[0]);

            } else if (sortColumn === "group") {
                // Группировка
                valA = keyA.split(" | ")[1] || "";
                valB = keyB.split(" | ")[1] || "";
            } else {
                valA = valueA[sortColumn] || 0;
                valB = valueB[sortColumn] || 0;
            }

            // Сравнение значений
            return sortOrder === "asc" ? (valA < valB ? -1 : valA > valB ? 1 : 0) : (valA < valB ? 1 : valA > valB ? -1 : 0);
        });
    }, [statistics, sortColumn, sortOrder]);

    const handleSort = (column) => {
        const newSortOrder = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        setSortColumn(column);
        setSortOrder(newSortOrder);
    };

    

    const renderSortIcon = (column) => {
        if (column === sortColumn) {
            return sortOrder === "asc" ? <FaArrowUp /> : <FaArrowDown />;
        }
        return null;
    };
    
    const totals = useMemo(() => {
        const vals = Object.values(statistics);
      
        const sum = vals.reduce((acc, s) => {
          acc.clicks        += s.clicks || 0;
          acc.registrations += s.registrations || 0;
          acc.purchase      += s.purchase || 0;      // ⬅ суммируем именно purchase
          acc.auto_debit    += s.auto_debit || 0;
          acc.income        += Number(s.income || 0);
          acc.tg_stars += s.tg_stars || 0;

          return acc;
        }, { clicks: 0, registrations: 0, purchase: 0, auto_debit: 0, income: 0, tg_stars: 0, });
      
        // CR = Покупки / Регистрации * 100 (без вычитания автосписаний)
        sum.cr  = sum.registrations > 0 ? (sum.purchase / sum.registrations) * 100 : 0;
      
        // EPC = Доход / Переходы
        sum.epc = sum.clicks > 0 ? (sum.income / sum.clicks) : 0;
      
        return sum;
      }, [statistics]);
      

    useEffect(() => {
        fetchStatistics().catch(error => setErrorMessage(error.message));
    }, [startDate, endDate, interval, groupBy, selectedOffers, selectedStreams]);


    const [showLegend, setShowLegend] = useState(false);
    const legendWrapRef = useRef(null);

    useEffect(() => {
    const onDocClick = (e) => {
        if (!legendWrapRef.current) return;
        if (!legendWrapRef.current.contains(e.target)) setShowLegend(false);
    };
    const onEsc = (e) => { if (e.key === 'Escape') setShowLegend(false); };

    document.addEventListener('mousedown', onDocClick);
    document.addEventListener('keydown', onEsc);
    return () => {
        document.removeEventListener('mousedown', onDocClick);
        document.removeEventListener('keydown', onEsc);
    };
    }, []);

    

    return (
        <div>
          <TopBar pageTitle="Статистика" />
          <div className="main-container">
            <SideBar />
            <main className="home-main flex-grow-1">
              <div className="fl-page">
      
                <div className="fl-subtabs">
                  <button className="fl-subtabs__btn is-active">Статистика</button>
                  <button className="fl-subtabs__btn" onClick={() => navigate("/conversions")}>
                    Конверсии
                  </button>
                </div>
      
                {errorMessage && <div className="error-message">{errorMessage}</div>}
      
                <div className="fl-toolbar">
                  <input className="fl-input" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                  <span className="fl-toolbar__dash">-</span>
                  <input className="fl-input" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
      
                  <select className="fl-select" onChange={handleIntervalChange} value={intervalUi}>
                    <option value="по дням">по дням</option>
                    <option value="по неделям">по неделям</option>
                    <option value="по месяцам">по месяцам</option>
                    <option disabled>──────────</option>
                    <option value="today">Сегодня</option>
                    <option value="yesterday">Вчера</option>
                  </select>
      
                  <select className="fl-select" onChange={(e) => setGroupBy(e.target.value)} value={groupBy}>
                    <option value="none">Нет группировки</option>
                    <option value="offer">по офферу</option>
                    <option value="stream">по потоку</option>
                    <option value="landing">по лендингу</option>
                  </select>
      
                  <button
                    className="fl-btn fl-btn--ghost fl-toolbar-action fl-toolbar-action--dots"
                    onClick={toggleFilters}
                    type="button"
                    title="Фильтры"
                  >
                    …
                  </button>
      
                  <button
                    className="fl-btn fl-toolbar-action fl-toolbar-action--update"
                    onClick={handleUpdateLoading}
                    disabled={loading}
                  >
                    Обновить
                  </button>
      
                  <div
                    ref={legendWrapRef}
                    className="fl-popwrap fl-toolbar-action fl-toolbar-action--info"
                  >
                    <button className="fl-icon-circle" type="button" onClick={() => setShowLegend(v => !v)} title="Что означают метрики">
                      i
                    </button>
      
                    {showLegend && (
                      <div className="fl-popover" role="dialog" aria-label="Справка по метрикам">
                        <div className="fl-popover__head">
                          <div className="fl-popover__title">Информация по статистике</div>
                          <button className="fl-popover__close" onClick={() => setShowLegend(false)} aria-label="Закрыть">×</button>
                        </div>
      
                        <ul style={{ margin: 0, paddingLeft: 16, fontSize: 12, lineHeight: 1.5, color: "var(--fl-text)" }}>
                          <li><b>Переходы</b> — люди, которые впервые запустили бота с <code>/start</code>.</li>
                          <li><b>CR</b> — процент покупок к числу регистраций.</li>
                          <li><b>EPC</b> — стоимость одного перехода.</li>
                          <li><b>Регистрации</b> — пользователи завершили регистрацию (поставили фото).</li>
                          <li><b>Автосписания</b> — количество успешно продлённых подписок.</li>
                          <li><b>Покупки</b> — количество первых покупок в боте.</li>
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
      
                {showFilters && (
                  <div className="fl-morefilters">
                    <div className="fl-morefilters__grid">
                      <div className="fl-field">
                        <div className="fl-label">Потоки</div>
                        {/* пока оставляем твой select multiple, но уже в макетной карточке */}
                        <select multiple value={selectedStreams} onChange={() => {}} style={{ height: 120, borderRadius: 16, border: "1px solid var(--fl-border)", padding: 8 }}>
                          {allStreams.map((stream) => (
                            <option key={stream} value={stream} onClick={() => toggleStreamSelection(stream)}>
                              {stream}
                            </option>
                          ))}
                        </select>
                      </div>
      
                      <div className="fl-field">
                        <div className="fl-label">Офферы</div>
                        <select multiple value={selectedOffers} onChange={() => {}} style={{ height: 120, borderRadius: 16, border: "1px solid var(--fl-border)", padding: 8 }}>
                          {allOffers.map((offer) => (
                            <option key={offer.id} value={offer.id} onClick={() => toggleOfferSelection(offer.id)}>
                              {offer.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
      
                {loading ? (
                  <div className="loading-container"><div className="loader"></div></div>
                ) : sortedStatistics.length > 0 ? (
                  <div className="fl-table-wrap">
                    <table className="fl-table">
                      <thead>
                        <tr>
                          <th onClick={() => handleSort("period")}>Период {renderSortIcon("period")}</th>
                          {groupBy !== "none" && (
                            <th onClick={() => handleSort("offer_name")}>
                              {groupBy === "offer" ? "Оффер" : groupBy === "stream" ? "Поток" : "Лендинг"} {renderSortIcon("offer_name")}
                            </th>
                          )}
                          <th onClick={() => handleSort("clicks")}>Переходы {renderSortIcon("clicks")}</th>
                          <th onClick={() => handleSort("cr")}>CR {renderSortIcon("cr")}</th>
                          <th onClick={() => handleSort("epc")}>EPC {renderSortIcon("epc")}</th>
                          <th onClick={() => handleSort("registrations")}>Регистрации {renderSortIcon("registrations")}</th>
                          <th onClick={() => handleSort("auto_debit")}>Автосписания {renderSortIcon("auto_debit")}</th>
                          <th onClick={() => handleSort("purchase")}>Покупки {renderSortIcon("purchase")}</th>
                          <th onClick={() => handleSort("tg_stars")}>TG Stars {renderSortIcon("tg_stars")}</th>
                          <th onClick={() => handleSort("income")}>Доход {renderSortIcon("income")}</th>
                        </tr>
                      </thead>
        
                      <tbody>
                        {sortedStatistics.map(([key, value]) => (
                          <tr key={key}>
                            <td>{key.split(" | ")[0]}</td>
                            {groupBy !== "none" && (
                              <td>{groupBy === "offer" ? (value.offer_name || "Неизвестный оффер") : key.split(" | ")[1]}</td>
                            )}
                            <td>{value.clicks || 0}</td>
                            <td>{value.cr.toFixed(2)}%</td>
                            <td>{value.epc.toFixed(2)}</td>
                            <td>{value.registrations || 0}</td>
                            <td>{value.auto_debit}</td>
                            <td>{value.purchase}</td>
                            <td>{value.tg_stars || 0}</td>
                            <td>{value.income.toFixed(2)} руб.</td>
                          </tr>
                        ))}
                      </tbody>
        
                      <tfoot>
                        <tr>
                          <td>Итого</td>
                          {groupBy !== "none" && <td></td>}
                          <td>{totals.clicks}</td>
                          <td>{totals.cr.toFixed(2)}%</td>
                          <td>{totals.epc.toFixed(2)}</td>
                          <td>{totals.registrations}</td>
                          <td>{totals.auto_debit}</td>
                          <td>{totals.purchase}</td>
                          <td>{totals.tg_stars}</td>
                          <td>{totals.income.toFixed(2)} руб.</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                ) : (
                    <div className="loading-container"><div className="loader"></div></div>
                  )}
      
              </div>
            </main>
          </div>
        </div>
      );
      
};
export default StatisticsPage;
